import * as React from "react";
import { Avatar, Button, Persona, Popover, PopoverSurface, PopoverTrigger } from "@fluentui/react-components";
import { PersonRegular, PersonFilled, bundleIcon } from "@fluentui/react-icons";

import SignOutButton from "./SignOutButton";
import SignInButton from "./SignInButton";

import { UserContext } from "../store/user-contex-api";
import { useIconButtonStyles } from "../styles/styles";

const UserIcon = bundleIcon(PersonFilled, PersonRegular);

export default function UserAccount() {
  const { isAuthenticated, name, email } = React.useContext(UserContext);
  const iconStyles = useIconButtonStyles();

  return (
    <Popover>
      <PopoverTrigger disableButtonEnhancement>
        <Button
          className={iconStyles.dark}
          appearance="subtle"
          icon={
            <Avatar
              color="colorful"
              icon={<UserIcon />}
              active="active"
              activeAppearance="shadow"
              name={name}
              size={24}
            />
          }
        />
      </PopoverTrigger>
      <PopoverSurface tabIndex={-1}>
        {isAuthenticated ? (
          <div className="flex flex-col gap-[10px]">
            <Persona
              textAlignment="start"
              name={name}
              secondaryText={email}
              size="huge"
              avatar={{
                color: "colorful",
              }}
            />
            <SignOutButton />
          </div>
        ) : (
          <SignInButton />
        )}
      </PopoverSurface>
    </Popover>
  );
}
